module.exports = __webpack_public_path__ + "static/media/api.adaf9503.svg";